export default "__VITE_ASSET__DEh3jp33__"